<template>
  <div>
    <v-container fluid>
      <v-layout class="mb-2">
        <v-flex class="text-xs-right">
          <v-btn
            outline
            color="grey"
            v-if="$store.getters.getPackage != 'premium'"
            v-tooltip.top="'Unlock to PREMIUM plan'"
            :loading="loading"
          >
            <i class="fas fa-file-export mr-1"></i> {{ $t('export') }}
            <v-premium-lock></v-premium-lock
          ></v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            @click="exportData"
            color="primary"
            outline
            class="ma-0 mb-1"
            :loading="loading"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <date-filter
        v-model="selectedDate"
        :showTime="true"
        @onSelected="getDashbroadShopAnalytic"
      ></date-filter>
      <div class="my-3">
        <v-layout row wrap>
          <v-flex xs12 lg3 class="pl-1">
            <v-card height="100%" class="pa-0">
              <v-card-text class="pb-1 statscard">
                <p class="mb-0">{{ $t('Total Orders') }}</p>
                <h5 class="headline text-xs-right mr-2">{{ totalorder | numberFormat }}</h5>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 lg9>
            <v-layout row wrap class="mb-0">
              <v-flex xs12 lg4 class="pl-1">
                <v-card height="100%" class="pa-0">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Total Sales') }}</p>
                    <h5 class="headline text-xs-right mr-2">{{ totalamount | numberFormat }}</h5>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 lg4 class="pl-1">
                <v-card height="100%" class="pa-0">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Total Sales (without Shipping Charge)') }}</p>
                    <h5 class="headline text-xs-right mr-2">
                      {{ (totalamount - totalshippingcharge) | numberFormat }}
                    </h5>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex lg4 xs12 class="pl-1">
                <v-card height="100%" class="pa-0">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Total Shipping Charge') }}</p>
                    <h5 class="headline text-xs-right mr-2">
                      {{ totalshippingcharge | numberFormat }}
                    </h5>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4 class="pt-1 pl-1">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Avg Sales / 1 Order') }}</p>
                    <h5 class="headline text-xs-right mr-2 mt-0 mb-1">
                      {{ (totalamount / totalorder) | numberFormat }}
                    </h5>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4 class="pt-1 pl-1">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Avg Sales (without Shipping Charge) / 1 Order') }}</p>
                    <h5 class="headline text-xs-right mr-2 mt-0 mb-1">
                      {{ ((totalamount - totalshippingcharge) / totalorder) | numberFormat }}
                    </h5>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4 class="pt-1 pl-1">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Avg Shipping Charge / 1 Order') }}</p>
                    <h5 class="headline text-xs-right mr-2 mt-0 mb-1">
                      {{ (totalshippingcharge / totalorder) | numberFormat }}
                    </h5>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <v-data-table
        expand
        :loading="loading"
        v-bind:pagination.sync="pagination"
        :headers="headers"
        :items="products"
        class="elevation-1 scgallrenttable"
      >
        <template v-slot:items="props">
          <tr>
            <!-- <td class="text-xs-center">{{ props.item.productid }}</td> -->
            <td class="text-xs-center">
              {{ props.item.productname ? props.item.productname : $t('All Deleted Products') }}
            </td>
            <td class="text-xs-center">{{ props.item.totalquantity | numberFormat }}</td>
            <td class="text-xs-center">{{ props.item.totalamount | numberFormat }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter'
import XLSX from 'xlsx'
import numeral from 'numeral'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      loading: true,
      totalamount: '',
      totalshippingcharge: '',
      totalorder: '',
      selectedDate: {
        start: moment()
          .subtract(7, 'days')
          .format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      headers: [
        {
          text: this.$t('Product Name'),
          value: 'productname',
          align: 'center',
          width: '3%',
          align: 'center'
        },
        {
          text: this.$t('Quantity'),
          value: 'totalquantity',
          align: 'center',
          width: '1%',
          align: 'center'
        },
        {
          text: this.$t('Sales'),
          value: 'totalamount',
          align: 'center',
          width: '2%',
          align: 'center'
        }
      ],
      products: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getDashbroadShopAnalytic()
  },
  methods: {
    getDashbroadShopAnalytic(date) {
      this.loading = true
      if (date) {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: date.start,
          dateto: date.end
        }
      } else {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: this.selectedDate.start,
          dateto: this.selectedDate.end
        }
      }

      api.getdashbroadshopanalytic(data, (error, response) => {
        this.loading = false
        if (response && response.responsecode == 200 && response.data) {
          this.products = response.data2
          this.totalamount = response.data.totalamount
          this.totalshippingcharge = response.data.totalshippingcharge
          this.totalorder = response.data.totalorder
        } else {
          this.products = []
          this.totalamount = 0
          this.totalshippingcharge = 0
          this.totalorder = 0
        }
      })
    },
    exportData() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      let json = []
      json.push([
        `${this.$t('from')} ` +
          moment(vm.selectedDate.start).format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          moment(vm.selectedDate.end).format('DD/MM/YYYY')
      ])

      json.push([])
      json.push([this.$t('Sales Report')])

      json.push([this.$t('Total Orders'), numeral(this.totalorder).format('0,0')])
      json.push([this.$t('Total Sales'), numeral(this.totalamount).format('0,0')])
      json.push([
        this.$t('Total Sales (without Shipping Charge)'),
        numeral(this.totalamount - this.totalshippingcharge).format('0,0')
      ])
      json.push([this.$t('Total Shipping Charge'), numeral(this.totalshippingcharge).format('0,0')])
      json.push([
        this.$t('Avg Sales / 1 Order'),
        numeral(this.totalamount / this.totalorder).format('0,0')
      ])
      json.push([
        this.$t('Avg Sales (without Shipping Charge) / 1 Order'),
        numeral((this.totalamount - this.totalshippingcharge) / this.totalorder).format('0,0')
      ])
      json.push([
        this.$t('Avg Shipping Charge / 1 Order'),
        numeral(this.totalshippingcharge / this.totalorder).format('0,0')
      ])

      const wb = XLSX.utils.book_new()
      wb.Props = {
        Title: 'Zwiz Sales Report',
        Subject: 'Sales Report',
        Author: 'Zwiz',
        CreatedDate: moment()
      }
      wb.SheetNames.push('Overall')
      const ws = XLSX.utils.aoa_to_sheet(json)
      wb.Sheets['Overall'] = ws
      wb.SheetNames.push('Products')
      var header = [this.$t('Product Name'), this.$t('Quantity'), this.$t('Sales')]
      var products = this.products.map(el => {
        return [
          el.productname ? el.productname : this.$t('All Deleted Products'),
          numeral(el.totalquantity).format('0,0'),
          numeral(el.totalamount).format('0,0')
        ]
      })
      products.unshift(header)
      const ws2 = XLSX.utils.aoa_to_sheet(products)
      wb.Sheets['Products'] = ws2

      XLSX.writeFile(wb, 'zwiz-salesreport.xlsx')
    }
  }
}
</script>

<style>
/* .scgallrenttable .v-table__overflow .v-datatable.v-table.theme--light thead tr th {
  padding: 0 !important;
  text-align: center;
} */
.statscard {
  display: flex;
  justify-content: space-between;
  height: 100%;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductAnalytics.vue